<template>
  <div class="bg-white">
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="container">
      <div class="common-body-width div-center">
        <div class="common-margin-top common-padding-top text-center font-28 common-letter-spacing">
          <span>我们提供的<span class="color-purple">系统</span>服务</span>
        </div>
        <div class="common-padding-top row">
          <div class="common-margin-top col col-12 col-md-4 col-lg-4">
            <div class="radius-shadow-0-2 common-padding-top common-padding-bottom common-margin-left-1 common-margin-right-1">
              <div class="color-purple font-14 common-padding-left-2 common-letter-spacing">会员相关</div>
              <div class="common-padding-top-1 common-padding-left-2 font-10 common-line-height-2 common-letter-spacing">
                1、支付即会员，快速沉淀会员。 <br />
                2、大数据分析会员消费轨迹。 <br />
                3、精准投放会员优惠券营销。 <br />
                4、推荐合适商家促进消费。 <br />
                5、在线下单，到店核销。<br />
                6、支付即送积分，积分跨店消费。<br />
              </div>
            </div>
          </div>
          <div class="common-margin-top col col-12 col-md-4 col-lg-4">
            <div class="radius-shadow-0-2 common-padding-top common-padding-bottom common-margin-left-1 common-margin-right-1">
              <div class="color-purple font-14 common-padding-left-2 common-letter-spacing">商家相关</div>
              <div class="common-padding-top-1 common-padding-left-2 font-10 common-line-height-2 common-letter-spacing">
                1、实时门店交易数据统计。<br />
                2、管理店铺会员。 <br />
                3、获得跨界收益。 <br />
                4、收款即锁客。 <br />
                5、跨店交换/投放广告引流。 <br />
                6、供货商、推广员实时分账。
              </div>
            </div>
          </div>
          <div class="common-margin-top col col-12 col-md-4 col-lg-4">
            <div class="radius-shadow-0-2 common-padding-top common-padding-bottom common-margin-left-1 common-margin-right-1">
              <div class="color-purple font-14 common-padding-left-2 common-letter-spacing">业务员相关</div>
              <div class="common-padding-top-1 common-padding-left-2 font-10 common-line-height-2 common-letter-spacing">
                1、实时统计业务员奖励。 <br />
                2、实时统计业务员分润。<br />
                3、实时统计拓展商家数量。<br />
                4、实时统计拓展商家交易额。<br />
                5、分地区管理业务员及数据。<br />
                6、快速拓展商户及管理商户。<br />
              </div>
            </div>
          </div>
          <div class="common-margin-top col col-12 col-md-4 col-lg-4">
            <div class="radius-shadow-0-2 common-padding-top common-padding-bottom common-margin-left-1 common-margin-right-1">
              <div class="color-purple font-14 common-padding-left-2 common-letter-spacing">商家设备</div>
              <div class="common-padding-top-1 common-padding-left-2 font-10 common-line-height-2 common-letter-spacing">
              1、扫码枪 <br />
              2、扫码盒 <br />
              3、商家收款码 <br />
              4、青蛙、蜻蜓刷脸设备 <br />
              5、商家收银插件 <br />
              6、商家收银系统
            </div>
            </div>
          </div>
          <div class="common-margin-top col col-12 col-md-8 col-lg-8">
            <div class="radius-shadow-0-2 text-top common-margin-left-1 common-margin-right-1">
            <div class="common-padding-1-5 text-center">
              <img class="col-10" :src="require('images/product/equipment.png')" />
            </div>
          </div>
          </div>
        </div>
        <div class="font-28 common-letter-spacing text-center common-margin-top common-padding-top">
          我们提供的<span class="color-purple">支付</span>服务
        </div>
        <div class="font-18 common-letter-spacing common-margin-top">
          多场景全渠道收款
        </div>
        <div class="common-letter-spacing-1 row">
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2  text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
              <img :src="require('images/home/scanpay.png')" />
              <div class="font-12 common-margin-top-2">扫码支付</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
            <img :src="require('images/home/barcode.png')" />
            <div class="font-12 common-margin-top-2">条码支付</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
            <img :src="require('images/home/h5.png')" />
            <div class="font-12 common-margin-top-2">APP支付</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
            <img :src="require('images/home/wechat.png')" />
            <div class="font-12 common-margin-top-2">公众号支付</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
            <img :src="require('images/home/h5.png')" />
            <div class="font-12 common-margin-top-2">H5支付</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
            <img :src="require('images/home/mini.png')" />
            <div class="font-12 common-margin-top-2">小程序支付</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
            <img :src="require('images/home/face.png')" />
            <div class="font-12 common-margin-top-2">刷脸支付</div>
            </div>
          </div>
        </div>
        <div class="font-18 common-letter-spacing common-margin-top common-padding-top-2">
          完备账户分润分佣体系
        </div>
        <div class="common-letter-spacing-1 common-margin-top-1 row">
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
              <img :src="require('images/home/sub-account.png')" />
              <div class="font-12 common-margin-top-2">分账系统</div>
            </div>
          </div>
          <div class="col col-6 col-md-3 col-lg-3 common-margin-top-2 text-center">
            <div class="common-margin-left-1 common-margin-right-1 radius-shadow-0-2 common-padding">
              <img :src="require('images/home/wallet.png')" />
              <div class="font-12 common-margin-top-2">商户钱包/提现(代付)</div>
            </div>
          </div>
        </div>
      </div>
      <div class="common-margin-top common-padding-top">
        <img class="my-col-10" :src="require('images/product/classroom.png')" />
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '新零售平台场景',
        url: '#',
        describe: '打造线上线下渠道一体化的新零售解决方案，用数据智能驱动企业增长。  ' +
          '支付即会员，快速锁客，支付即送优惠券，促进二次消费，快捷引流，高效收款，精准投放广告。'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Xls.vue